import React from "react";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Header from "../../components/Header/Header";
import { isMobile } from "react-device-detect";

function Authentic() {
  const navigate = useNavigate();
  const [isIFrameVisible, setIsIFrameVisible] = useState(false);
  const [searchParams] = useSearchParams();
  const [isApp] = useState(searchParams?.get("app") || 0);
  return (
    <>
      {/* Header */}
      {!isApp ?
      <Header
        mobileHeaderOptions={{
          menuIcon: false,
          wishlistIcon: false,
          darveysLargeTextIcon: false,
          searchIcon: false,
          shoppingBagIcon: false,
          backButtonIcon: false,
          crossButtonIcon: true,
          pageHeadingShow: true,
          pageHeadingText: "100% Authentic",
          darveysSmallIcon: false,
          userAccountIcon: false,
        }}
      />
      :
      ""
      }

      <div className="clearfix"></div>

      <section className="about-page spacer-dsk pb-4">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-12 col-12">
              <div className="heading text-center d-dsk">
                <h3>100% Authentic</h3>
              </div>
              <div className="about-img mt-30 mt-sm-0">
                {!isIFrameVisible && (
                  <>
                    <img
                      src="../assets/images/authentic-desktop.jpg"
                      className="img-fluid mx-auto d-dsk"
                      alt=""
                      onClick={() => {
                        setIsIFrameVisible(true)
                        window.$("#popupVideoIframeID")[0].src += '&autoplay=1';
                      }}
                    />
                    <img
                      src="../assets/images/12-100_-Authentic.jpg"
                      className="img-fluid mx-auto d-mbl"
                      alt=""
                      onClick={() => {
                        setIsIFrameVisible(true); 
                        window.$("#popupVideoIframeID")[0].src += '&autoplay=1';
                      }}
                    />
                  </>
                )}

                <iframe
                  id = "popupVideoIframeID" 
                  src="https://www.youtube.com/embed/PUgciBjn73I?modestbranding=1&enablejsapi=1&rel=0&controls=1&autohide=1&playsinline=1&mute=1"
                  frameBorder="0"
                  allow="autoplay; encrypted-media"
                  allowFullScreen
                  title="video"
                  style={{ display: isIFrameVisible ? "block" : "none",width:"100%",height:isMobile? "":"554px" }}
                />
              </div>
              <div className="text-center auth-text mt-30">
                <p>
                  Our <span className="text-black">authenticity guarantee</span>{" "}
                  extends to{" "}
                  <span className="text-black">2x the price in return.</span>{" "}
                  You can read about us in{" "}
                  <span className="text-black">
                    <a rel={"noreferrer"} target={"_blank"} style={{textDecoration:"underline"}} href ="https://economictimes.indiatimes.com/industry/services/retail/how-nakul-bajajs-online-marketplace-darveys-offers-global-luxury-brands-at-up-to-70-discount/articleshow/48217148.cms">The Economic Times</a>
                    {" "}and{" "}
                    <a rel={"noreferrer"} target={"_blank"} style={{textDecoration:"underline"}} href="https://www.forbesindia.com/article/best-things-money-can-buy/darveys-offering-luxury-at-a-discount/55733/1">Forbes Magazine</a>.
                  </span>
                </p>
                <p className="mt-30">
                  We provide{" "}
                  <span className="text-black">
                    upto 60% off on 70+ luxury brands
                  </span>{" "}
                  directly sourced from authorised stores in USA and Europe. All
                  prices are inclusive of duties &amp; taxes.
                </p>
                <p className="mt-30">
                  We have served{" "}
                  <span className="text-black">
                    2 lakh+ satisfied customers
                  </span>{" "}
                  in India over last 6 years.
                </p>
              </div>
            </div>
            <div className="col-md-4 col-7 mx-auto mt-35 text-center">
              <button
                className="btn-primary authentic-button btn-fw"
                onClick={(e) => navigate("/catalog/men")}
              >
                Shop Men
              </button>
            </div>
            <div className="col-md-4 col-7 mx-auto mt-20 text-center">
              <button
                className="btn-primary authentic-button btn-fw"
                onClick={(e) => navigate("/catalog/women")}
              >
                Shop Women
              </button>
            </div>
            <div className="col-md-4 col-7 mx-auto mt-20 text-center">
              <button
                className="btn-primary authentic-button btn-fw"
                onClick={(e) => navigate("/catalog/all/kids")}
              >
                Shop Kids
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Authentic;
